import React, { useEffect, useRef, useState, FC } from "react";
import { Button, message } from "antd";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef, ISelectOption } from "@/components/YhFormBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/FmsDictEnums";
import { usePurchasePoDetailsModel } from "../scmPurchasePoModel";
import { ISCMPoFormFields } from "../scmPurchasePoType";
import useGlobalModel from "@/model/globalModel";

// import { preferentialOption, brandOption } from "@/types/FmsDs";


export const FormBox: FC<RouterParamType> = ({ id, mode }) => {
    const formRef = useRef<IYhFormRef>();
    const { beShopDs, fetchSupplierList } = useGlobalModel();
    const { lookFormVal, getPoDetailOne, resetLookCatch, } = usePurchasePoDetailsModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    // const { getSelectedDictOne } = useDictModel(() => []);
    const [more, setMore] = useState<boolean>(true);  //控制更多按钮
    //编辑时， 没有缓在调用详情接口
    useEffect(() => {
        getPoDetailOne(id)
    }, []);

    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            resetLookCatch();
        }
    }, [selectedNavId])


    const baseFormItem: IYhFormItemsBox = {
        title: "基础信息",
        style: { padding: "10px 0 0 0", marginBottom: "15px" },
        contentClass: "pr-77",
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "采购单号",
                fieldName: "purchaseCode",
                disable: true,
                placeholder: "自动生成"
            },
            {
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: "供应商",
                fieldName: "supplierName",
                placeholder: "供应商",
                rules: [{ required: true, message: "请选择供应商" }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "整单下浮",
                fieldName: "discountRate",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "应付金额",
                fieldName: "totalAmount",
                disable: true
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "采购类型",
                fieldName: "purchaseTypeName",
                rules: [{ required: true, message: "请选择采购类型" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系人",
                fieldName: "contact",
                rules: [{ required: true, message: "请输入联系人" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "入库金额",
                fieldName: "stockIoTotalAmount",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "已付金额",
                fieldName: "paidAmount",
                disable: true,
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "采购单位",
                fieldName: "bentityName",
                options: beShopDs,
                rules: [{ required: true, message: "请选择采购单位" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
                rules: [{ required: true, message: "请输入联系电话" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "整单优惠",
                fieldName: "favorableAmount",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "优惠总额",
                fieldName: "discountTotalAmount",
                disable: true
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "品牌",
                fieldName: "brandName",
                rules: [{ required: true, message: "请选择配件品牌" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商类型",
                fieldName: "supplierTypeName",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 10,
                labelCol: { span: 4 },
                colClassName: "detail-note-col"
            }, {
                type: FormItemTypeEnum.Button,
                fieldLabel: <a className="color-blue text-line" onClick={() => setMore(!more)}>{more ? '更多>>' : "隐藏"}</a>,
                fieldName: "",
                span: 2,
                labelCol: { span: 16, offset: 8 },
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "发票类型",
                fieldName: "invoiceTypeName",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "优惠类型",
                fieldName: "preferentialTypeName",
                allowClear: true,
                rules: [{ required: true, message: "该项为必填项" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "运输通知单号",
                fieldName: "transportCode",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "业务员",
                fieldName: "operator",
                disable: true,
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "库管",
                fieldName: "storekeeper",
                disable: true,
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算员",
                fieldName: "reckoner",
                disable: true,
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发运单号",
                fieldName: "deliveryCode",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "财务",
                fieldName: "casher",
                disable: true,
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "入库日期",
                fieldName: "stockIoTime",
                disable: true,
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算日期",
                fieldName: "settleTime",
                disable: true,
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单人",
                fieldName: "createUser",
                disable: true,
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单日期",
                fieldName: "createTime",
                disable: true,
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改人",
                fieldName: "updateUser",
                disable: true,
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改日期",
                fieldName: "updateTime",
                disable: true,
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "从属门店",
                fieldName: "shopName",
                disable: true,
                hidden: more
            },
            //带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商名称",
                fieldName: "supplierName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商类型code",
                fieldName: "supplierTypeCode",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "采购类型name",
                fieldName: "purchaseTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "采购单位名称",
                fieldName: "bentityName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票类型名称",
                fieldName: "invoiceTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "优惠类型名称",
                fieldName: "preferentialTypeName",
                hidden: true
            }
        ]
    };

    const poFromConfig: IYhFormBox<ISCMPoFormFields> = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: "right",
        formValues: lookFormVal,
        disabled: true,
        // onChange,
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...poFromConfig} />
    )
}